/**
 * Phase 0 reference preset.
 *
 * The numerical values come from `src/engine/phase0Reference.ts`, which is
 * the single source of truth for the Phase 0 anti-regression baseline. This
 * module just wraps them as a VisualizerPreset.
 */

import {
  PHASE0_NAME,
  PHASE0_SEED,
  PHASE0_WARP,
} from '../../phase0Reference';
import type { VisualizerPreset } from '../presetTypes';

export const phase0ReferencePreset: VisualizerPreset = {
  id: PHASE0_NAME,
  name: 'Phase 0 reference',
  seed: { kind: 'waveform', params: { ...PHASE0_SEED } },
  warp: {
    kind: PHASE0_WARP.kind,
    params: {
      baseZoom: PHASE0_WARP.baseZoom,
      bassZoomGain: PHASE0_WARP.bassZoomGain,
      rotation: PHASE0_WARP.rotation,
      bassRotationGain: PHASE0_WARP.bassRotationGain,
      ripple: PHASE0_WARP.ripple,
      rippleFreq: PHASE0_WARP.rippleFreq,
      decay: PHASE0_WARP.decay,
      chroma: PHASE0_WARP.chroma,
      hueShift: PHASE0_WARP.hueShift,
      beatPunch: PHASE0_WARP.beatPunch,
      centerDriftAmp: PHASE0_WARP.centerDriftAmp,
      centerDriftRate: PHASE0_WARP.centerDriftRate,
    },
  },
  // Phase 0 had no declarative modulation; its bass/beat reactivity is built
  // into the shader's bassZoomGain / beatPunch params themselves. Keep the
  // declarative list empty so this preset *is* the anti-regression baseline.
  modulation: [],
  transition: { durationMs: 800 },
};
